import { TrainingApiBase } from '@/libs/apis/training/base';

export class DomainApi extends TrainingApiBase {
  list() {
    return super.get('domain/', 'Failed to get email domains');
  }
}
